import React, { useContext, useState } from 'react';
import { Flex, Text, Box, IconButton, useDisclosure, Button, Icon } from '@chakra-ui/react';
import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '@chakra-ui/modal';
import { MdClose, MdOutlineWarning } from 'react-icons/md';
import PersonaThumbnail from '../../../persona/components/personaThumbnail';
import { PersonaContext } from '../../../persona/lib/personaContext';
import { useSharedExperiencesApi } from '../../lib/useSharedExperiencesApi';
export default function PersonaInSharedExperienceListItem({ sharedExperienceId, onUpdate }) {
  const { persona } = useContext(PersonaContext);
  const [isDeleting, setIsDeleting] = useState(false);
  const modalDelete = useDisclosure();
  const sharedExperiencesApi = useSharedExperiencesApi();
  async function removePersonaFromSharedExperience() {
    try {
      setIsDeleting(true);
      await sharedExperiencesApi.unlinkPersonaFromSharedExperience(
        sharedExperienceId,
        persona.id
      );
      setIsDeleting(false);
      modalDelete.onClose();
      if (onUpdate) {
        onUpdate();
      }
    } catch (e) {
      console.error(e);
      setIsDeleting(false);
    }
  }
  return (
    <>
      <Flex
        alignItems="center"
        justifyContent="space-between"
        backgroundColor="white"
        role={'group'}
        flex={1}
        mb={1}
        px={3}
        h={"34px"}
        _hover={{
          backgroundColor: 'background.grey',
          borderRadius: '2px'
        }}
      >
        <Flex alignItems={"center"}>
          <PersonaThumbnail
            size={24}
            personaId={persona.id}
            hasThumbnail={persona.has_thumbnail}
          />
          <Text ml={2}>{persona.name}</Text>
        </Flex>
        <Box style={{ opacity: '0' }} _groupHover={{ opacity: '1 !important' }} >
          <IconButton
            icon={<MdClose />}
            size={'md'}
            variant='greyTransparent'
            onClick={(e) => {
              modalDelete.onOpen();
              e.stopPropagation();
              e.preventDefault();
            }}
          />
        </Box>
      </Flex>
      <Modal isOpen={modalDelete.isOpen} onClose={modalDelete.onClose}>
        <ModalOverlay />
        <ModalContent >
          <ModalHeader>Remove Persona {persona.name}</ModalHeader>
          <ModalBody p={3} >
            <Flex
              border="1px"
              borderColor="divider.grey"
              borderRadius="2px"
              backgroundColor="white"
              alignItems={'center'}
              p={3}
            >
              <Icon
                as={MdOutlineWarning}
                color={'text.medium.red'}
                boxSize={'18px'}
                mr={3}
              />
              <Text textStyle="body" color={'text.medium.red'} >
                Are you sure to remove the persona {persona.name} from this shared experiences?
              </Text>
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button
              variant='redOutline'
              onClick={modalDelete.onClose}
            >Close</Button>
            <Button
              variant="redFill"
              ml={2}
              isLoading={isDeleting}
              onClick={removePersonaFromSharedExperience}>Remove</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
} 